import { formatCustomDate } from "helpers/dateTools";

export const initialValues = {
  idStation: null,
  date: formatCustomDate(new Date(), '-'),
  idUnit: null,
  initialMileage: 0,
  finalMileage: 0,
  carburation: 0,
  type: null,
  withOrder: true,
  sgcID: null,
}

export const requiredValues = (withOrder = true) => {
  return {
  idStation: { required: true },
  date: { required: true },
  idUnit: { required: true },
  initialMileage: { required: false },
  finalMileage: { required: true },
  carburation: { required: true },
  type: { required: true },
  sgcID: { required: withOrder },
}
}